// src/helpers/langselect.js
import React from "react"
import { useLingui } from "@lingui/react"
import { dynamicActivate } from "../App.js";


const wholeFunction = async (langcode) => {
    await dynamicActivate(langcode);
}

const LanguageSelector = () => {
    const { i18n } = useLingui();
    return (
        <div style={{justifyContent : "center"}}> {/* Inline style here is fine for direct child, but can be external CSS */}
            <button
                onClick={() => {wholeFunction('en')}}
                disabled={i18n.locale === 'en'}>
                <span>EN</span> {/* CHANGED from <lib> */}
            </button>
            <button
                onClick={() => {wholeFunction('es')}}
                disabled={i18n.locale === 'es'}>
                <span>ES</span> 
            </button>
            {/*<button
                onClick={() => {wholeFunction('pt')}}
                disabled={i18n.locale === 'pt'}>
                <span>PT</span> 
            </button>
            <button
                onClick={() => {wholeFunction('it')}}
                disabled={i18n.locale === 'it'}>
                <span>IT</span> 
            </button>
            <button
                onClick={() => {wholeFunction('de')}}
                disabled={i18n.locale === 'de'}>
                <span>DE</span> 
            </button>*/}
        </div>
    )
};
export default LanguageSelector;